import { SET_PROGRESS, SET_UPLOADED_URLS, SET_UPLOADING, SET_ERROR, SET_DRAG_ACTIVE, DELETE_PENDING_FILE, CLEAR_PENDING_FILES, RESET_MEDIA_STATE, PUSH_FILES } from './actions';
import { state as initialState } from './state';
export const reducer = (state, { type, payload }) => {
    switch (type) {
        case PUSH_FILES:
            return { ...state, files: [...state.files, ...payload] };
        case DELETE_PENDING_FILE:
            return {
                ...state,
                files: state.files.filter((file, i) => i !== payload)
            };
        case SET_PROGRESS:
            return { ...state, progress: payload };
        case SET_UPLOADED_URLS:
            return { ...state, uploadedUrls: [...state.uploadedUrls, ...payload] };
        case SET_UPLOADING:
            return { ...state, uploading: payload };
        case SET_ERROR:
            return { ...state, error: payload };
        case SET_DRAG_ACTIVE:
            return { ...state, isDragActive: payload };
        case CLEAR_PENDING_FILES:
            return { ...state, files: [] };
        case RESET_MEDIA_STATE:
            return { ...initialState };
        default:
            return state;
    }
};
